export default __webpack_public_path__ + "static/media/bg-crossing-2.083d16ee.svg";